
import { CallMethod } from "csi/xml/CallMethod";
import csi from "csi/main";
import declare from "dojo/_base/declare";
import New from "csi/table/New";
import xml from "csi/xml";

/* Fields */
const PROJECT = "Project";
const SKU_BOMS = "SKUBOMs";
const SKU_FOOD_BOM = "SKUFoodBOM";
const SKU_RECIPES = "SKURecipes";
const SKU_RECIPE = "SKURecipe";
const SKU_LABEL_DATA_SHEETS = "SKULabelDataSheets";
const SKU_FOOD_LABEL = "SKUFoodLabel";

const NewFoodSKUController = declare(New, {

	/**
	 * @override
	 * Add Default DataSheets to datasheet containers (FoodBOM, Recipe, Food Label)
	 *
	 */
	toWriterRequest(): CallMethod {
		// Add Default BOM
		const skuBoms = this.m_formData.getFieldValue(SKU_BOMS);
		const defaultFoodBom = this.m_formData.getFieldValue(SKU_FOOD_BOM);

		const isDefaultFoodBomSelected = defaultFoodBom !== csi.EMPTY_URL;
		if (skuBoms && isDefaultFoodBomSelected && !skuBoms?.includes(defaultFoodBom)) {
			skuBoms.push(defaultFoodBom);
		}

		// Add Default Recipe
		const skuRecipes = this.m_formData.getFieldValue(SKU_RECIPES);
		const defaultRecipe = this.m_formData.getFieldValue(SKU_RECIPE);

		const isDefaultRecipeSelected = defaultRecipe !== csi.EMPTY_URL;
		if (skuRecipes && isDefaultRecipeSelected && !skuRecipes?.includes(defaultRecipe)) {
			skuRecipes.push(defaultRecipe);
		}

		// Add Default Label
		const skuLabels = this.m_formData.getFieldValue(SKU_LABEL_DATA_SHEETS);
		const defaultLabel = this.m_formData.getFieldValue(SKU_FOOD_LABEL);

		const isDefaultLabelSelected = defaultLabel !== csi.EMPTY_URL;
		if (skuLabels && isDefaultLabelSelected && !skuLabels?.includes(defaultLabel)) {
			skuLabels.push(defaultLabel);
		}

		const call = this.inherited<CallMethod>(arguments);
		const projectField = this.m_formData.getFieldById(PROJECT);
		const projectFieldVal = projectField && this.m_formData.getFieldValue(projectField, true);
		if (projectFieldVal) {
			call.addParameter(PROJECT, xml.ATTR_REF, projectFieldVal);
		}

		return call;
	},

});

export = NewFoodSKUController;
